import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminGuard = ({ children }) => {
  const adminToken = localStorage.getItem("admin_token");
  const adminUser = JSON.parse(localStorage.getItem("admin_user") || "{}");

  if (!adminToken || adminUser.role !== "super_admin") {
    console.warn("Access Denied: Admin privileges required.");
    return <Navigate to="/admin/login" replace />;
  }

  return children ? children : <Outlet />;
};

export default AdminGuard;
